import { APIMethod, fetchData } from "@client";

export async function removeProjectObserverQuery(uuid, email) {
  const data = { uuid, email };
  return await fetchData("/project/remove", APIMethod.POST, { data });
}
